export default __webpack_public_path__ + "static/media/multikart-logo.ed98f772.png";